/**
 * Legacy LLP invoice line parsing (`currentLineTable.handleRowClick`).
 * Example: "Matson Montilla-LEAP-2847740" -> "LEAP-2847740"
 */
export const getRiderIdFromDescription = (description = '') => {
  const text = `${description}`.trim();
  const parts = text.split(/-LEAP-/i);
  if (!parts[1]) return null;

  const numericPart = `${parts[1].split('-')[0] || ''}`.trim();
  if (!/^\d+$/.test(numericPart)) return null;

  return `LEAP-${numericPart}`.toUpperCase();
};
